<template>
  <div class="formContainer">

    <form class="formularioBusqueda" @submit.prevent="loadOrderData">

      <div class="formGroup">
        <label>Documento</label>

        <select v-model="selectedDocument" required>
          <option value="" disabled>Seleccione...</option>

          <option
            v-for="document in documentsData"
            :key="document.documento"
            :value="document.documento"
          >
            {{ document.documento }}
          </option>

        </select>
      </div>

      <div class="formGroup">
        <label>Cliente</label>
        <input type="text" v-model="selectedClient" required>
      </div>
      <div class="formGroup">
        <label>Orden</label>
        <input type="text" v-model="selectedOrder" required>
      </div>
      <div class="formActions">
        <button type="submit" class="loginbtn primaryBtn">
          Buscar
        </button>
      </div>
    </form>
  </div>
</template>
<script>
//Importa el componente de Vuex
import IberoHelpers from '@/store/helpers.js'

  export default {
    components: {
        IberoHelpers,
    },
    data () {
      return {
        documentsData : [],
        selectedDocument : null,
        selectedClient : null,
        selectedOrder : null,
        orderData : [],
      }
    },
    mounted () {
       this.loadDocumentsData();
    },
    methods: {
        //Método que carga los datos del select de "Documento"
        loadDocumentsData(){
          IberoHelpers.GetLiquidacionOrdenDocumentsIceberg(this.$store, 0)
                .then(response => {
                    this.documentsData = response.data;
                })
                .catch(error => {
                    console.error('Error loading data:', error);
                });
        },
        //Método que carga los datos de las ordenes desde Iceberg, se le pasa "Cliente", "Documento" y "Orden" como parámetros
        async loadOrderData() {
          try {
            let response = await IberoHelpers.GetLiquidacionOrderIceberg(this.$store, this.selectedClient, this.selectedDocument, this.selectedOrder);

            if (response.data.length === 0) {
              this.orderData = [{
                Registro: 0,
                Secuencia: 0,
                ColumnName: "",
                ValorAnterior: "",
                ValorAccion: "",
                Accion: "",
                Fecha: "",
                Terminal: "",
                Usuario: "",
                ObjectName: ""
              }]; // Objeto por defecto
            } else {
              this.orderData = response.data;
            }
            this.$emit('showResultOrder', this.orderData);
          } catch (error) {
            console.error('Error loading data:', error);
          }
        }
        
    },
  }
</script>